import { TabContentProps } from '../types'

import { TabItem, TabLayout, TabType } from './Tabs'
import { TextContent } from './TextContent/TextContent'
import { LayoutContent } from './LayoutContent/LayoutContent'
import { TemplatesContent } from './TemplatesContent/TemplatesContent'
import { DesktopDesignContent as StyledDesktopDesignContent } from './styles'

type Props = TabContentProps & {
  tab: TabType
  tabItems: TabItem<TabType>[]
  onTabChange: (tab: TabType) => void
}

export const DesktopDesignContent = ({ tab, resume, tabItems, onTabChange }: Props) => {
  const ContentComponent: Record<TabType, React.ReactNode> = {
    templates: <TemplatesContent resume={resume} />,
    text: <TextContent resume={resume} />,
    layout: <LayoutContent resume={resume} />,
  }

  return (
    <StyledDesktopDesignContent>
      <TabLayout activeTab={tab} items={tabItems} onTabChange={onTabChange} />
      {ContentComponent[tab]}
    </StyledDesktopDesignContent>
  )
}
